<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('Message.Prompt')"
      width="340px"
      class="change-order-dialog"
      :close-on-click-modal="false"
      :show-close="true"
      @close="cancel"
    >
      <div class="main-content">
        <el-form label-width="100px" label-position="left">
          <el-form-item v-show="form.jobNo" :label="$t('SeaExport.BusinessNo') + `：`">
            <span>{{ form.jobNo }}</span>
          </el-form-item>
          <el-form-item v-show="form.mbl" label="MBL NO：">
            <span>{{ form.mbl }}</span>
          </el-form-item>
          <el-form-item v-show="form.hbl" label="HBL NO：">
            <span>{{ form.hbl }}</span>
          </el-form-item>
          <div v-show="form.tip">
            <el-form-item v-show="form.tip.customerCompanyName" :label="$t('CargoMsg.Cargo_Parter') + `：`">
              <span>{{ form.tip.customerCompanyName || '' }}</span>
            </el-form-item>
            <el-form-item v-show="form.tip.customerOverCreditLimitAmount" :label="$t('CargoMsg.Cargo_CreditLine') + `：`">
              <span>{{ $t('CargoMsg.Cargo_ExceededAmount', [form.tip.customerOverCreditLimitAmount]) }}</span>
            </el-form-item>
            <el-form-item v-show="form.tip.customerOverCreditLimitDate" :label="$t('CargoMsg.Cargo_CreditAccountingPeriod') + `：`">
              <span>{{ $t('CargoMsg.Cargo_Exceeded') }}</span>
            </el-form-item>
            <el-form-item v-show="form.tip.agentCompanyName" :label="$t('CargoMsg.Cargo_Parter') + `：`">
              <span>{{ form.tip.agentCompanyName || '' }}</span>
            </el-form-item>
            <el-form-item v-show="form.tip.agentOverCreditLimitAmount" :label="$t('CargoMsg.Cargo_CreditLine') + `：`">
              <span>{{ $t('CargoMsg.Cargo_ExceededAmount', [form.tip.agentOverCreditLimitAmount]) }}</span>
            </el-form-item>
            <el-form-item v-show="form.tip.agentOverCreditLimitDate" :label="$t('CargoMsg.Cargo_CreditAccountingPeriod') + `：`">
              <span>{{ $t('CargoMsg.Cargo_Exceeded') }}</span>
            </el-form-item>
            <el-form-item v-show="form.tip.accountCompanyName" :label="$t('CargoMsg.Cargo_Parter') + `：`">
              <span>{{ form.tip.accountCompanyName || '' }}</span>
            </el-form-item>
            <el-form-item v-show="form.tip.accountOverCreditLimitAmount" :label="$t('CargoMsg.Cargo_CreditLine') + `：`">
              <span>{{ $t('CargoMsg.Cargo_ExceededAmount', [form.tip.accountOverCreditLimitAmount]) }}</span>
            </el-form-item>
            <el-form-item v-show="form.tip.accountOverCreditLimitDate" :label="$t('CargoMsg.Cargo_CreditAccountingPeriod') + `：`">
              <span>{{ $t('CargoMsg.Cargo_Exceeded') }}</span>
            </el-form-item>
            <span v-if="!isReleasing">{{ $t('ReleaseNotes.lineCreditDialog.triggerRemind') }}</span>
            <span v-else>{{ $t('CargoMsg.Cargo_ContinueToReleaseDocuments') }}</span>
          </div>
        </el-form>

        <div slot="footer" style="text-align:right; margin-top: 20px">
          <el-button v-show="index > 0" no="Previous" type="primary" @click="lastHandler">{{ $t('CargoMsg.Cargo_Previous') }}</el-button>
          <el-button v-show="index < releaseRules.length - 1" no="NextItem" type="primary" @click="nextHandler">{{ $t('CargoMsg.Cargo_NextItem') }}</el-button>
          <el-button v-show="isReleasing" no="confirm" @click="confirm">{{ $t('common.btn.confirm') }}</el-button>
          <el-button no="cancel" @click="cancel">{{ $t('common.btn.close') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import DateUtils from '@/utils/dateUtils'

export default {
  name: 'ReleaseRuleResultWindow',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    releaseRules: { type: Array, required: false, default: () => [] },
    data: { type: Array, required: false, default: () => [] },
    isReleasing: { type: Boolean, default: false }
  },
  data() {
    return {
      index: 0
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    },
    form() {
      const length = this.releaseRules && this.releaseRules.length > 0 ? this.releaseRules.length : 0
      const index = length > this.index ? this.index : length - 1
      return this.releaseRules && this.releaseRules.length > 0 ? this.releaseRules[index] : {}
    }
  },
  methods: {
    cancel() {
      this.index = 0
      this.$emit('close')
    },
    nextHandler() {
      this.index += 1
    },
    lastHandler() {
      this.index -= 1
    },
    confirm() {
      const param = {}
      param['releaseState'] = ReleaseState.ONSINGLERELEASE.code
      param['reviewDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
      param['withhold'] = false
      param['operation'] = ReleaseState.ONSINGLERELEASE.code + ''
      this.cancel()
      this.$emit('confirm', this.data, param)
    }
  }
}
</script>
<style scoped>

</style>

